import { createSlice } from '@reduxjs/toolkit';
import { fetchProcurementStatus, archiveProcurementData } from '../../api/procurementApi';

const procurementSlice = createSlice({
  name: 'procurement',
  initialState: {
    interactionId: null,
    totalRawMaterialList: [],
    summaryRawMaterialList: [],
    loading: false,
    error: null,
    archiveSuccess: false,
  },
  reducers: {
    clearProcurementState: (state) => {
      state.interactionId = null;
      state.totalRawMaterialList = [];
      state.summaryRawMaterialList = [];
      state.loading = false;
      state.error = null;
      state.archiveSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcurementStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.archiveSuccess = false;
      })
      .addCase(fetchProcurementStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.interactionId = action.payload.interactionId;
        state.totalRawMaterialList = action.payload.totalRawMaterialList;
        state.summaryRawMaterialList = action.payload.summaryRawMaterialList;
      })
      .addCase(fetchProcurementStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(archiveProcurementData.pending, (state) => {
        state.loading = true;
        state.archiveSuccess = false;
      })
      .addCase(archiveProcurementData.fulfilled, (state) => {
        state.loading = false;
        state.archiveSuccess = true;
      })
      .addCase(archiveProcurementData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearProcurementState } = procurementSlice.actions;
export default procurementSlice.reducer;

